export const genderArray = ["male","female","others"]